import { render, staticRenderFns } from "./SimulationExamPriceModalComponent.vue?vue&type=template&id=395b94d2&scoped=true&"
import script from "./SimulationExamPriceModalComponent.vue?vue&type=script&lang=js&"
export * from "./SimulationExamPriceModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./SimulationExamPriceModalComponent.vue?vue&type=style&index=0&id=395b94d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b94d2",
  null
  
)

export default component.exports